import { gql } from '@apollo/client'
import ORGANIZATION_TPA_FRAGMENT from 'apollo/fragments/ORGANIZATION_TPA_FRAGMENT'
import PAGINATED_PAGE_INFO_FRAGMENT from 'apollo/fragments/PAGINATED_PAGE_INFO_FRAGMENT'

// MEMBERS_FOR_SELECT

export default gql`
  query membersForSelect($cursor: String, $filters: MembersFilterInput) {
    members(first: 25, after: $cursor, filters: $filters) {
      nodes {
        id
        first_name
        last_name
        dob
        shared_id
        organization {
          ...ORGANIZATION_TPA_FRAGMENT
        }
      }
      pageInfo {
        ...PAGINATED_PAGE_INFO_FRAGMENT
      }
    }
  }
  ${ORGANIZATION_TPA_FRAGMENT}
  ${PAGINATED_PAGE_INFO_FRAGMENT}
`
